export const EMPTY_CART = 'EMPTY_CART';




// WEBPACK FOOTER //
// ./src/store/modules/cart/mutationsTypes.js